export default __webpack_public_path__ + "static/media/pancard.ace4f0d5.svg";